module.exports = __webpack_public_path__ + "media/images/lb/767-8790beba8f8ffe970a1e16530c0515bf.svg";